import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { displayDate, displayDateAndTime } from "../../../../helper-functions";
import { useTIFFormData } from "../../../../hooks";
import PhotoThumbnail from "../../../photos/PhotoThumbnail";
import { isMicrokeratome, TissueTypes } from "../../../../models";
import { AutoCol } from "../../../../component-library";
import { TissueInformationFormProps } from ".";

export function TIFPostProcedureGradingOther({ tissueId }: Readonly<TissueInformationFormProps>) {
    const {
        fetchGradingCaseFileUrls,
        postProcedureEval,
        postProcedureEvalSummary,
        latestPostProcessingSlitLamp,
        caseFileUrls,
        latestProcedure,
        postProcessingFiles,
        postProcessingOverallRating,
        tissue,
    } = useTIFFormData({ tissueId });

    useEffect(() => {
        fetchGradingCaseFileUrls(postProcessingFiles);
    }, [fetchGradingCaseFileUrls, postProcessingFiles]);

    const tissueType: TissueTypes = tissue?.tissueType?.name as TissueTypes;

    if (!tissue) {
        return <div>No tissue found</div>;
    }

    return (
        <Row>
            <Col>
                <div style={{ fontWeight: "bold" }}>POST-PROCESSING:</div>
                <div>
                    {tissueType} Tissue Number: {tissue?.number}
                </div>

                {!latestProcedure?.viewingChamberNa && (
                    <>
                        <span className="me-2">
                            Viewing Chamber Manufacturer: {latestProcedure?.viewingChamberManufacturerName}
                        </span>
                        <span className="me-2">Lot No.: {latestProcedure?.viewingChamberManufacturerLotNumber}</span>
                        <span>Exp Date: {displayDate(latestProcedure?.viewingChamberManufacturerExpDate)}</span>
                        <div>
                            Estimated maximum graft size: <b>{postProcedureEval?.data?.graft?.graftSize} mm</b>
                        </div>
                    </>
                )}
                {isMicrokeratome(latestProcedure?.procedureType?.name) && (
                    <>
                        <div>Pre-cut OCT Pachymetry Reading: {latestProcedure?.pachymetryReading} µm</div>
                        <div>
                            <b>
                                Post-Processing Graft Thickness:
                                {postProcedureEval?.data?.stroma?.posteriorThickness} µm Size:{" "}
                                {postProcedureEval?.data?.stroma?.size} mm
                            </b>
                        </div>
                    </>
                )}
                <div>{postProcedureEvalSummary}</div>
                <div>
                    <b>Cell Count: {postProcedureEval?.data?.endothelium?.cellCount} cell/mm </b>
                    {postProcedureEval?.signedByName}, {displayDateAndTime(postProcedureEval?.signedOn)}
                </div>
                <div>
                    <span className="me-2">
                        Slit Lamp D/T: {displayDateAndTime(latestPostProcessingSlitLamp?.createdOn)}
                    </span>
                    <span>Slit Lamp Tech: {latestPostProcessingSlitLamp?.createdByUserName}</span>
                </div>
                <div>
                    Post-Processing Overall Rating - <b>{postProcessingOverallRating}</b>
                </div>
            </Col>
            <AutoCol>
                {postProcessingFiles?.map((cf) => (
                    <PhotoThumbnail
                        key={cf.id}
                        caseFile={cf}
                        url={caseFileUrls[cf.id]}
                        maxHeight="110px"
                        maxWidth="110px"
                        className="m-0"
                    />
                ))}
            </AutoCol>
        </Row>
    );
}
